import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import Chart from 'chart.js/auto';
import * as moment from 'moment';
import { DoctorDashboardService } from 'src/app/services/doctor-dashboard.service/doctor-dashboard.service';

@Component({
  selector: 'app-chart-rdv-by-periode',
  templateUrl: './chart-rdv-by-periode.component.html',
  styleUrls: ['./chart-rdv-by-periode.component.css'],
})
export class ChartRdvByPeriodeComponent implements OnInit, AfterViewInit {
  @ViewChild('rdvPeriodeCanvas') rdvPeriodeCanvas!: ElementRef;

  private chart!: Chart;
  private chartInitialized = false;

  public rdvs: Array<number> = [];

  startDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1);
  finDate: Date = new Date();

  constructor(
    private doctorDashboardService: DoctorDashboardService,
    private ngZone: NgZone
  ) {}

  get canvasContext(): any {
    return this.rdvPeriodeCanvas.nativeElement.getContext('2d');
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.staticRdv();
      this.chartInitialized = true;
    });
  }

  staticRdv() {
    if (!this.rdvPeriodeCanvas) return; // guard important

    const startDate = new Date(this.startDate).getTime();
    const endDate = new Date(this.finDate).getTime();

    this.doctorDashboardService.staticRdvs(startDate, endDate).subscribe((res) => {
      this.chart?.destroy(); // détruire l'ancien chart si existant

      this.chart = new Chart(this.canvasContext, {
        type: 'line',
        data: {
          labels: res.map((elm) =>
            moment(new Date(elm.creationDate)).format('DD/MM/YYYY')
          ),
          datasets: [
            {
              label: `Nombre de Rendez-vous Entre ${moment(startDate).format('DD/MM/YYYY')} Et ${moment(endDate).format('DD/MM/YYYY')}`,
              data: res.map((elm) => elm.pCount),
              fill: true,
              backgroundColor: 'transparent',
              borderColor: 'rgba(69, 204, 206, 1)',
              borderWidth: 1,
              tension: 0.6,
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    });
  }

  onDateChange(): void {
    if (!this.chartInitialized) return;
    this.ngZone.runOutsideAngular(() => {
      this.staticRdv();
    });
  }
}